import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionComponent } from '../shared/components/subscription/subscription.component';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SubscriptionService{
  private selectedProductSubject = new BehaviorSubject<any>(null);
  selectedProduct$ = this.selectedProductSubject.asObservable();
  pdfUrl: any;
  constructor(private modalService: NgbModal,) {}
  showSubscriptionExpiredModal() {
    const modalRef: NgbModalRef = this.modalService.open(SubscriptionComponent, {
      centered: true,
      keyboard: false,      
      backdrop: 'static',   
      windowClass: 'subscription-modal'
    });
  }

  //Check-Avilibity For Set Selected Product
  setSelectedProduct(product: any): void {
    this.selectedProductSubject.next(product);
  }

  //Check-Avilibity For Get Selected Product
  getSelectedProduct(): Observable<any> {
    return this.selectedProduct$;
  }

  //Check-Avilibity For Reset Selected Product
  resetSelectedProduct(): void {
    this.selectedProductSubject.next(null);
  }

  setPdfBlobUrl(url: any) {
    this.pdfUrl = url;
  }

  getPdfBlobUrl() {
    return this.pdfUrl;
  }

}